import { PREVIOUS_AUTH_SYSTEM_KEY } from '@/constants/authKeys';
import { getValueFromLocalstore } from '@/services/localStorage.service';
import { getUseGCAuth } from '@/utils/getUseGCAuth';
import store from '@/store';

const MAGIC_LINK_ROUTES = ['/auth/link/', '/auth/embedded', '/auth/sso'];

export function applySessionAuthSystem(): void {
  const useGCAuth = getUseGCAuth();
  const previousAuthSystem = getValueFromLocalstore(PREVIOUS_AUTH_SYSTEM_KEY);

  if (MAGIC_LINK_ROUTES.some(route => window.location.pathname.includes(route))) {
    store.commit('event/setUseGCAuth', useGCAuth);
    return;
  }

  if (!previousAuthSystem) {
    store.commit('event/setUseGCAuth', useGCAuth);
    return;
  }

  const previousWasGCAuth = previousAuthSystem === 'gcauth';
  store.commit('event/setUseGCAuth', previousWasGCAuth);
}
